import Echo from "laravel-echo";
import "pusher-js";

/**
 * @param {import("vuex").Store} store
 */
export const makeEchoPlugin = store => {
  return {
    install(vue) {
      const EchoManager = new Echo({
        broadcaster: "pusher",
        key: process.env.VUE_APP_PUSHER_APP_KEY,
        cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER || "",
        wsHost: process.env.VUE_APP_PUSHER_HOST,
        wsPort: process.env.VUE_APP_PUSHER_PORT,
        wssPort: process.env.VUE_APP_PUSHER_PORT,
        forceTLS: false,
        encrypted: true,
        disableStats: true,
        enabledTransports: ["ws", "wss"],
        authEndpoint: process.env.VUE_APP_API_HOST + "/api/broadcasting/auth",
        auth: {
          headers: {
            // Authorization: `Bearer ${authStore.accessToken}`,
          },
        },
      });
      EchoManager.connector.pusher.connection.bind("state_change", function(states) {
        store.commit("setSocketStatus", states.current);
      });
      if (store.state.auth.accessToken) {
        EchoManager.connector.options.auth.headers.Authorization = store.state.auth.accessToken;
      }

      store.watch(
        state => {
          return state.auth.accessToken;
        },
        newToken => {
          if (newToken) {
            EchoManager.connector.options.auth.headers.Authorization = newToken;
            EchoManager.connect();
            return;
          }

          EchoManager.disconnect();
        },
        {
          deep: true,
        },
      );

      vue.prototype.$echo = EchoManager;
    },
  };
};
